<app-breadcrumb [breadcrumb]="'ecomproduct'" class="hidevalue"></app-breadcrumb>


<!-- <div *ngIf="Order.length == 0 && hidval == false"  id="orderloader">
    <div style="height: 743px;">
       
        <div class="preloader">
            <div class="loader">
                <div class="loaderzig">
                    <div class="loader__part loader__part--1"></div>
                    <div class="loader__part loader__part--2"></div>
                    <div class="loader__part loader__part--3"></div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="container" style="padding-top: 5%; 
    padding-bottom: 5%;" *ngIf="Order.length == 0 && hidval == true" id="cartmessage">
    <div class="col-sm-12 empty-cart-cls text-center">
        <img src="assets/images/icon-empty-cart.png" class="img-fluid mb-4">
        <h3><strong>Your Order is Empty</strong></h3>
        <!-- <h4>Add something to make me happy :)</h4> -->
    </div>
    <div class="col-12 text-center py-md-4 pt-4">
        <a [routerLink]="['/shop/collection/left/sidebar']" class="btn btn-solid">continue shopping</a>
    </div>
</div>



<section class="section-b-space" style="position: static;" *ngIf="Order.length > 0" id="orderdetail">
    <div class="container">
        <div class="checkout-page">
            <div class="checkout-form">
                <div class="row">
                    <div class="col-lg-3 col-sm-12 col-xs-12 hidevalue" *ngIf="OrdStatusID == -100">

                        <div class="checkout-details" style="margin-bottom: 20px;border: 0;padding: 0;">

                            <div class="collection-filter-block">
                                <app-services></app-services>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-12 col-xs-12 hidevalue" *ngIf="OrdStatusID != -100">

                        <div class="checkout-details" style="margin-bottom: 20px;border: 0;">

                            <div class="checkout-title" *ngIf="PendingOrder">
                                <h3>Track Order</h3><br>
                                <p><strong style="color: black;">OrderId:</strong><span
                                        style="color: #ff4c3b;margin-left: 5px;">#{{PendingOrder.ino}}|{{PendingOrder.Id}}</span>
                                </p>

                            </div>
                            <div class="stepper-vertical" id="stepper1" *ngIf="PendingOrder.osi > -1">
                                <div class="step editing">
                                    <div class="step-container col-12">
                                        <div class="step-title col-1"></div>
                                        <div class="step-circle col-2"><span>1</span></div>
                                        <div class="step-title col-9">Order Pending</div>
                                    </div>
                                    <div class="step-container col-12">
                                        <div class="col-1"></div>
                                        <div class="step-bar col-2"></div>
                                        <div class="col-9"></div>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-container col-12">
                                        <div class="step-title col-1"></div>
                                        <div class="step-circle col-2"><span>2</span></div>
                                        <div class="step-title col-9">Order Received</div>
                                    </div>
                                    <div class="step-container col-12">
                                        <div class="col-1"></div>
                                        <div class="step-bar col-2"></div>
                                        <div class="col-9"></div>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-container col-12">
                                        <div class="step-title col-1"></div>
                                        <div class="step-circle col-2"><span>3</span></div>
                                        <div class="step-title col-9">Order Processing</div>
                                    </div>
                                    <div class="step-container col-12">
                                        <div class="col-1"></div>
                                        <div class="step-bar col-2"></div>
                                        <div class="col-9"></div>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-container col-12">
                                        <div class="step-title col-1"></div>
                                        <div class="step-circle col-2"><span>4</span></div>
                                        <div class="step-title col-9">Out Of Delivery</div>
                                    </div>
                                    <div class="step-container col-12">
                                        <div class="col-1"></div>
                                        <div class="step-bar col-2"></div>
                                        <div class="col-9"></div>
                                    </div>
                                </div>
                                <div class="step">
                                    <div class="step-container  col-12">
                                        <div class="step-title col-1"></div>
                                        <div class="step-circle  col-2"><span>5</span></div>
                                        <div class="step-title  col-9">
                                            <span *ngIf="OrdStatusID!=5">Order will Arrive on</span>
                                            <span *ngIf="OrdStatusID==5">Order Delivered</span>

                                            <br>
                                            <p *ngIf="PendingOrder" style="font-size: small;">{{PendingOrder.didt
                                                | date: "d MMM Y | hh:mm: a" }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span *ngIf="PendingOrder.osi == -1" style="color: red;font-size: 18px;">Order
                                Cancelled</span>

                            <span *ngIf="PendingOrder.osi == -5" style="color: rgb(238, 157, 36);font-size: 18px;">Your
                                Cancel Request is Pending <i class="fa fa-clock-o" aria-hidden="true"></i></span>
                        </div>
                    </div>



                    <!-- PRODUCT DETAILS -->



                    <div class="col-lg-9 col-sm-12 col-xs-12 hidevalue">





                        <div class="checkout-details " *ngIf="mainhide == false && hide == false"
                            style="padding: 12px;border: 0;">
                            <div class="order-box">

                                <div class="checkout-title">

                                    <div class="row">
                                        <div class="col-9">
                                            <h3 style="margin-top: 5px;">Orders</h3>
                                        </div>
                                        <div class="col-3">
                                            <div>
                                                <select [(ngModel)]="Ofiltid" (change)="sorting($event)">
                                                    <option value="0" [selected]="0">Current Month Orders</option>
                                                    <option value="1" [selected]="1">Current Year Orders</option>
                                                    <option value="2" [selected]="2">All Orders</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>



                                </div>

                                <div *ngIf="Order==401">
                                    <div>
                                        <p>Something Error, Plz logout and login Again!</p>
                                    </div>
                                </div>

                                <div *ngIf="Order!=401">
                                    <div class="card" *ngFor="let ord of Order"
                                        style="border-radius: 10px;  margin-top: 15px;  ">
                                        <div class="card-body">

                                            <div class="row">
                                                <div class="col-3">
                                                    <h5 style="font-weight: 600;">Ordered Date&Time</h5>
                                                    <span>{{ord.oddt | date: "d MMM Y | hh:mm a" }}</span>
                                                </div>

                                                <div class="col-3">
                                                    <h5 style="font-weight: 600;">Delivery Date&Time</h5>
                                                    <span>{{ord.didt | date: "d MMM Y | hh:mm a" }}</span>
                                                </div>

                                                <div class="col-3">
                                                    <h5><span style="font-weight: 600;">#Order-ID</span> :
                                                        <span style="color: #ff4c3b;margin-left: 5px;">{{ord.id}} <span
                                                                *ngIf="ord.oi > 0">_{{ord.oi}}</span></span>
                                                    </h5>


                                                    <strong *ngIf="ord.osi == 0">
                                                        <p>Your Order is Pending</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == 1">
                                                        <p>Your Order is Accepted</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == 2">
                                                        <p>Your Order is Preparing</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == 3">
                                                        <p>Your Order is Prepared</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == 4">
                                                        <p>Out Of Delivery</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == 5">
                                                        <p style="color: green;">Your Order is Delivered</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == -1">
                                                        <p style="color: red;">Your Order is Cancelled</p>
                                                    </strong>
                                                    <strong *ngIf="ord.osi == -5">
                                                        <p style="color: rgb(238, 157, 36);">Your Cancel Request is
                                                            pending <i class="fa fa-clock-o" aria-hidden="true"></i></p>
                                                    </strong>
                                                </div>


                                                <div class="col-3">
                                                    <h5 style="font-weight: 600;">Total</h5>
                                                    <span>&#8377;{{ord.ta | number:'1.2-2'}}</span>

                                                    <a href="javascript:void(0)" (click)="getDetails(ord.id,ord.osi)"
                                                        style="color:red;    float: inline-end;
                                                ">View
                                                        Orders<span
                                                            style="color:red; margin-left: 5px;font-size: 16px;margin-left: 10px;">

                                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                        </span>
                                                    </a>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div> <br><br>

                                <div style="width: 100%;">
                                    <a href="javascript:void(0)" style="color:red; float:left" (click)="shopmore()">
                                        Shop More
                                        <span style="color:red; margin-left: 5px;font-size: 16px;">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </span>
                                    </a>
                                </div>

                                <!-- <table class="table cart-table table-responsive-xs hidetable">
                                    <thead>
                                        <tr>
                                         
                                            <th>DeliveryDate&Time</th>
                                            <th>Invoice-Id</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                            <th>Details</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let ord of Order">                                        
                                            <td style="width: 20%;">
                                                <span>{{ord.didt | date: "d MMM Y" }}</span>

                                                <div class="mobile-cart-content row">
                                                    <div class="col-12">

                                                        <strong *ngIf="ord.osi == 1">
                                                            <p>Your Order is Preparing</p>
                                                        </strong>
                                                        <strong *ngIf="ord.osi > 1">
                                                            <p style="color: green;">Your Order is Completed</p>
                                                        </strong>

                                                    </div><br>
                                                    <div class="col-12">

                                                        <span>#Order-ID</span> <strong
                                                            style="padding-left: 10px;">{{ord.ino}}</strong>

                                                    </div>

                                                    <div style="margin-top: 15px;">
                                                        <a (click)="getDetails(ord.Id,ord.osi)"
                                                            style="color: #4b91f6;">View
                                                            Details<span
                                                                style="color: #4b91f6;margin-left: 5px;font-size: 16px;margin-left: 10px;">

                                                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>

                                            <td style="width:30%;"> {{ord.ino}}</td>

                                            <td style="width: 20%;"> &#8377;{{ord.ta | number:'1.2-2'}}</td>

                                            <td style="width: 20%;">
                                                <strong *ngIf="ord.osi == 1">Pending</strong>
                                                <strong *ngIf="ord.osi > 1">Completed</strong>

                                            </td>

                                            <td style="width: 10%;">
                                                <a (click)="getDetails(ord.Id,ord.osi)">
                                                    <strong><i class="fa fa-info-circle trackicon"
                                                            aria-hidden="true"></i></strong>

                                                </a>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table> -->
                            </div>
                        </div>

                        <div class="col-sm-12 col-xs-12  hidevalue" *ngIf="hide == false && mainhide == true">
                            <h5 style="font-size: 20px;font-weight: 700;                            
                            line-height: 20px;">Order-Details</h5>
                            <span class="spandet">Ordered on {{PendingOrder.oddt | date: "d MMM Y | hh:mm:ss a" }}
                                <!-- <span class="spanicon">|</span>  -->
                            </span>



                            <!-- <span class="spandet" *ngIf="PendingOrder"
                                style="color: #ff4c3b;margin-left: 5px;">#{{PendingOrder.ino}}{{PendingOrder.Id}}</span> -->
                            <button type="submit" class="btn-solid btn btn-sm float-end" (click)="back()">
                                Back
                            </button>
                            <a style="float: inline-end;margin-right: 30px;margin-top: 10px;color: #ff4c3b;"
                                href="javascript:void(0)" (click)="generatePDF('download')"><i class="fa fa-print"
                                    aria-hidden="true"></i><span style="margin-left: 5px;">Download Invoice</span> </a>

                            <a style="float: inline-end;margin-right: 15%;margin-top: 10px;color: #ff4c3b;"
                                *ngIf="hidecancelbtn == true && PendingOrder.osi != -5" href="javascript:void(0)"
                                (click)="cancelOrder()"><i class="fa fa-times-circle" aria-hidden="true"></i><span
                                    style="margin-left: 5px;">Cancel
                                    Order</span> </a>


                            <a style="float: inline-end;margin-right: 15%;margin-top: 10px;color: orange;"
                                *ngIf="hidecancelbtn == true && PendingOrder.osi == -5" href="javascript:void(0)"
                                (click)="cancelOrder()"><i class="fa fa-times-circle" aria-hidden="true"></i><span
                                    style="margin-left: 5px;">Cancel
                                    Pending</span> </a>

                            <!-- <div *ngIf="PendingOrder">

                                <p style="font-size: 14px;color: black;">
                                    <strong style="font-size: 14px;">Hi
                                        {{PendingOrder.ca.Name}},</strong>
                                </p>
                                <p style="font-size: 14px;">Order Is Successfully
                                    Processsed And Your Order Is On The
                                    Way,</p>
                                <p style="font-size: 14px;">Transaction ID :
                                    {{PendingOrder.ino}},</p>

                            </div> -->
                            <div class="card" style="border-radius: 10px;  margin-top: 15px;  ">
                                <div class="card-body" style="    padding: 10px;">


                                    <div class="row" style="font-size: 16px;">
                                        <div class="col-4">
                                            <h5 class="h5det">Shipping Address</h5>
                                            <span *ngIf="PendingOrder.ca"
                                                style="font-size: 14px;">{{PendingOrder.ca.Address}},{{PendingOrder.ca.City}}-{{PendingOrder.ca.Pincode}}</span>
                                        </div>
                                        <div class="col-4">

                                            <h5 class="h5det">Payment Method</h5>
                                            <span style="font-size: 14px;" *ngIf="PendingOrder.pti == 1">Online
                                                Payment</span>
                                            <span style="font-size: 14px;" *ngIf="PendingOrder.pti == 2">Cash On
                                                Delivery</span><br>
                                            <!-- <span *ngIf="PendingOrder.ts == 0">Payment Pending</span> -->
                                            <span *ngIf="PendingOrder.ts == 1" style="color: green;">Payment
                                                Success</span>
                                            <span *ngIf="PendingOrder.ts == -1" style="color: red;">Payment
                                                Failed</span>
                                            <span *ngIf="PendingOrder.ts == 0" style="color:orange;">Payment
                                                Pending</span>
                                        </div>
                                        <div class="col-4">


                                            <h5 class="h5det">Order Total</h5>

                                            <!-- <span>Cash On Delivery</span> -->
                                            <div class="row" style="font-size: 16px">
                                                <div class="col">
                                                    <span style="font-size: 14px;">SubTotal</span><br>
                                                </div>
                                                <div class="col" *ngIf="PendingOrder">

                                                    <b style="float: right;font-size: 14px;">₹{{PendingOrder.subTotal
                                                        |
                                                        number:'1.2-2'}}</b><br>
                                                </div>

                                            </div>

                                            <div class="row" style="font-size: 16px;margin-top: 10px;">
                                                <div class="col">
                                                    <span style="font-size: 14px;">Tax 18%</span><br>

                                                </div>
                                                <div class="col" *ngIf="PendingOrder">
                                                    <b style="float: right;font-size: 14px;">₹{{PendingOrder.txa |
                                                        number:'1.2-2'}}</b><br>
                                                </div>

                                            </div>

                                            <div class="row" style="font-size: 16px;margin-top: 10px;"
                                                *ngIf="PendingOrder.ordcoupAmt > 0">
                                                <div class="col">
                                                    <span style="font-size: 14px;    color: #808080;">Coupon
                                                        Savings</span><br>
                                                </div>
                                                <div class="col" *ngIf="PendingOrder">

                                                    <b style="float: right;font-size: 14px;    color: #808080;">-
                                                        ₹{{PendingOrder.ordcoupAmt |
                                                        number:'1.2-2'}}</b><br>
                                                </div>

                                            </div>
                                            <div class="row" style="font-size: 16px;margin-top: 10px;">
                                                <div class="col">
                                                    <span style="font-size: 14px;">Grand Total</span><br>

                                                </div>
                                                <div class="col" *ngIf="PendingOrder">
                                                    <b style="float: right;font-size: 14px;">₹{{PendingOrder.ta |
                                                        number:'1.2-2'}}</b>
                                                </div>

                                                <div class="row"
                                                    *ngIf="PendingOrder.pti == 1 && PendingOrder.osi !=5 && PendingOrder.osi !=-5 && PendingOrder.ts != 1">
                                                    <a href="javascript:void(0)" style="margin-top: 10px;"
                                                        (click)="proceedToPayment()"><i class="fa fa-credit-card"
                                                            aria-hidden="true"></i>
                                                        Proceed to Payment
                                                    </a>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div class="card" style="border-radius: 10px;    margin-top: 20px;"
                                *ngFor="let item of PendingOrder.j">
                                <div class="card-body" style="    padding: 10px;">
                                    <div class="row">
                                        <div class="col-2">

                                            <img src={{item.product.img}} alt="" style="    width: 50%; ">
                                        </div>
                                        <div class="col-5">
                                            <h5>{{item.product.name}} <span>{{item.product.wg_qtytxt}}
                                                </span>
                                            </h5>
                                            <h5 *ngIf="item.product.message.length > 0"
                                                style="font-size: 14px; color:#444; margin-bottom: 0px;font-style: italic;">
                                                <span>"{{item.product.message}}"</span>
                                            </h5>
                                            <h5 *ngFor="let opt of item.product.addons"
                                                style="font-size: 14px; color:#444;    margin-bottom: 0px;">
                                                <span>{{opt.name}}</span>
                                            </h5>
                                            <h5 *ngIf="item.product.v_id!=null"
                                                style="font-size: 14px; color:#444; margin-bottom: 0px;">
                                                <span>{{item.product.v_name}}</span>
                                            </h5> <br>

                                            <a href="javascript:void(0)" style="color:red;"
                                                (click)="reviewmodel(item,PendingOrder.oi,PendingOrder.cui)"
                                                *ngIf="OrdStatusID == 5">
                                                Review<span
                                                    style="color:red; margin-left: 5px;font-size: 16px;margin-left: 10px;">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                                </span>
                                            </a>
                                        </div>

                                        <div class="col-5">
                                            <div class="row" style="font-size: 16px;margin-top: 10px;">
                                                <div class="col">
                                                    <span>Qty</span> <span style="float: inline-end;">:</span><br>

                                                </div>
                                                <div class="col">
                                                    <b>{{item.product.quantity}}</b><br>
                                                </div>
                                                <div class="col">

                                                </div>

                                            </div>
                                            <div class="row" style="font-size: 16px;margin-top: 10px;">
                                                <div class="col">
                                                    <span>Price</span> <span style="float: inline-end;">:</span><br>

                                                </div>
                                                <div class="col">
                                                    <b>₹{{item.product.prodtotal}}</b><br>
                                                </div>
                                                <div class="col">

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>


                        </div><br><br>

                        <!-- <div class="order-box hidevalue" *ngIf="hide == false && mainhide == true">
                            <div class="container">
                                <tbody>
                                    <tr>
                                        <td>
                                            <table cellpadding="0" cellspacing="0" style="text-align: left;"
                                                width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td style="text-align: center;">
                                                            <img src="../assets/images/Delivery-det/delivery-2.png"
                                                                alt="" style="margin-bottom: 30px;">
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="PendingOrder">
                                                        <td>
                                                            <p style="font-size: 14px;color: black;">
                                                                <strong style="font-size: 14px;">Hi
                                                                    {{PendingOrder.ca.Name}},</strong>
                                                            </p>
                                                            <p style="font-size: 14px;">Order Is Successfully
                                                                Processsed And Your Order Is On The
                                                                Way,</p>
                                                            <p style="font-size: 14px;">Transaction ID :
                                                                {{PendingOrder.ino}},</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <table cellpadding="0" cellspacing="0" border="0" align="left"
                                                style="width: 100%;margin-top: 10px;    margin-bottom: 10px;">
                                                <tbody>
                                                    <tr *ngIf="PendingOrder">
                                                        <td>
                                                            <h5
                                                                style="font-size: 16px; font-weight: 500;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                Billing ADDRESS</h5>
                                                            <p
                                                                style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                {{PendingOrder.ca.Address}}</p>
                                                        </td>
                                                        <td width="57" height="25" class="user-info"><img
                                                                src="../assets/images/Delivery-det/space.jpg" alt=" "
                                                                height="25" width="57"></td>
                                                        <td>
                                                            <h5
                                                                style="font-size: 16px;font-weight: 500;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                SHIPPING ADDRESS</h5>
                                                            <p
                                                                style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                268 Cambridge Lane New Albany, IN 47150268
                                                                Cambridge
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table class="order-detail" border="0" cellpadding="0" cellspacing="0"
                                                align="left" style="width: 100%;    margin-bottom: 0px;">
                                                <tbody>
                                                    <tr align="left">
                                                        <th style="text-align: center;">PRODUCT</th>
                                                        <th style="padding-left: 15px;">DESCRIPTION</th>
                                                        <th>QUANTITY</th>
                                                        <th style="text-align: end;">PRICE </th>
                                                    </tr>
                                                    <tr *ngFor="let item of PendingOrder.j">
                                                        <td style="text-align: center;">
                                                            <img src={{item.product.img}} alt="" style="    width: 50px;
                                                            ">
                                                        </td>
                                                        <td valign="top" style="padding-left: 15px;">
                                                            <h5>{{item.product.name}} -
                                                                {{item.weight.qty}} KG </h5>
                                                            <h5 *ngIf="item.product.message.length > 0"
                                                                style="font-size: 14px; color:#444; margin-bottom: 0px;font-style: italic;">
                                                                <span>{{item.product.message}}</span>
                                                            </h5>
                                                            <h5 *ngFor="let opt of item.options.addons"
                                                                style="font-size: 14px; color:#444;    margin-bottom: 0px;">
                                                                <span>{{opt.name}}</span>
                                                            </h5>
                                                            <h5 *ngIf="item.options.variants"
                                                                style="font-size: 14px; color:#444; margin-bottom: 0px;">
                                                                <span>{{item.options.variants.name}}</span>
                                                            </h5>
                                                        </td>
                                                        <td valign="top" style="padding-left: 15px;">

                                                            <h5 style="font-size: 14px; color:#444;">
                                                                <span>{{item.product.quantity}}</span>
                                                            </h5>
                                                        </td>
                                                        <td valign="top" style="padding-left: 15px;">
                                                            <h5 style="font-size: 14px; color:#444;text-align: end;">
                                                                <b>₹{{item.product.ProdTotal}}</b>
                                                            </h5>
                                                        </td>
                                                    </tr>                                                  


                                                    <tr class="pad-left-right-space ">
                                                        <td class="m-t-5" colspan="2" align="left">
                                                            <p style="font-size: 14px;">Subtotal : </p>
                                                        </td>
                                                        <td class="m-t-5" colspan="2" align="right"
                                                            *ngIf="PendingOrder">
                                                            <b style="float: right;">₹{{PendingOrder.subTotal |
                                                                number:'1.2-2'}}</b>
                                                        </td>
                                                    </tr>
                                                    <tr class="pad-left-right-space" *ngIf="PendingOrder">
                                                        <td class="m-t-5" colspan="2" align="left">
                                                            <p style="font-size: 14px;">Tax :</p>
                                                        </td>
                                                        <td class="m-t-5" colspan="2" align="right">
                                                            <b style="float: right;">₹{{PendingOrder.txa |
                                                                number:'1.2-2'}}</b>
                                                        </td>
                                                    </tr>
                                             
                                                    <tr class="pad-left-right-space " *ngIf="PendingOrder">
                                                        <td class="m-b-5" colspan="2" align="left">
                                                            <p style="font-size: 14px;">Total :</p>
                                                        </td>
                                                        <td class="m-b-5" colspan="2" align="right">
                                                            <b style="float: right;">₹{{PendingOrder.ta |
                                                                number:'1.2-2'}}</b>
                                                        </td>
                                                    </tr>                                                  
                                                    <tr>
                                                        <td style="border-style: none;"></td>
                                                        <td style="border-style: none;"></td>
                                                        <td style="border-style: none;"></td>
                                                        <td style="border-style: none;">
                                                            <button type="submit" class="btn-solid btn btn-sm"
                                                                (click)="back()">
                                                                Back
                                                            </button>
                                                        </td>
                                                     
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </td>
                                    </tr>
                                </tbody>


                            </div>
                        </div> -->




                        <!-- <div class="order-box hidevalue" *ngIf="hide == true && mainhide == true">
                            <div class="container">
                                <tbody>
                                    <tr>
                                        <td>
                                            <table align="center" border="0" cellpadding="0" cellspacing="0">
                                                <tbody>
                                                    <tr *ngIf="PendingOrder.osi == 5">
                                                        <td style="text-align: center;border-bottom-style: hidden;"
                                                            class="p-0">
                                                            <img src="../assets/images/Delivery-det/delivery-Sus.png"
                                                                alt="" style="margin-bottom: 5px;">
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="PendingOrder.osi == 5">
                                                        <td style="text-align: center;border-bottom-style: hidden;"
                                                            class="p-0">
                                                            <img src="../assets/images/Delivery-det/success.png" alt="">
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="PendingOrder.osi == 5">
                                                        <td style="text-align: center;border-bottom-style: hidden;"
                                                            class="p-0">
                                                            <h2 class="title">thank you</h2>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="PendingOrder.osi != 5">
                                                        <td style="text-align: center;">
                                                            <img src="../assets/images/Delivery-det/delivery-2.png"
                                                                alt="" style="margin-bottom: 30px;">
                                                        </td>
                                                    </tr>


                                                    <tr *ngIf="PendingOrder">
                                                        <td style="    text-align: -webkit-center;border-bottom-style: hidden;"
                                                            class="p-0">
                                                            <p>Payment Is Successfully Processsed And Your Order Is
                                                                On The
                                                                Way</p>
                                                            <p>Transaction ID:{{PendingOrder.ino}}</p>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                            <table class="order-detail" border="0" cellpadding="0" cellspacing="0"
                                                align="left">
                                                <tbody>
                                                    <tr align="left">
                                                        <th style="text-align: center;">PRODUCT</th>
                                                        <th style="padding-left: 15px;">DESCRIPTION</th>
                                                        <th>QTY</th>
                                                        <th>PRICE </th>
                                                    </tr>
                                                    <tr *ngFor="let ord of PendingOrder.j">
                                                        <td style="text-align: center;">
                                                            <img src={{ord.product.img}} alt="" style="width: 50px;">
                                                        </td>
                                                        <td valign="top" style="padding-left: 15px;">
                                                            <h5 style="margin-top: 15px;">{{ord.product.name}}
                                                                {{ord.weight.qty}} KG </h5>

                                                            <h5 *ngIf="ord.product.message.length > 0"
                                                                style="font-size: 14px; color:#444;    margin-bottom: 0px;">
                                                                MSGqq :<span>{{ord.product.message}}</span>
                                                            </h5>
                                                            <h5 *ngFor="let opt of ord.options.addons"
                                                                style="font-size: 14px; color:#444;    margin-bottom: 0px;">
                                                                <span>{{opt.name}}</span>
                                                            </h5>
                                                            <h5 *ngIf="ord.options.variants"
                                                                style="font-size: 14px; color:#444; margin-bottom: 0px;">
                                                                <span>{{ord.options.variants.name}}</span>
                                                            </h5>
                                                        </td>
                                                        <td valign="top" style="padding-left: 15px;">
                                                            <h5 style="font-size: 14px; color:#444;margin-top: 10px;">

                                                                <span>{{ord.product.quantity}}</span>
                                                            </h5>
                                                        </td>
                                                        <td valign="top" style="padding-left: 15px;">
                                                            <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                                <b>{{ord.product.ProdTotal}}</b>
                                                            </h5>
                                                        </td>
                                                    </tr>

                                                    <tr *ngIf="PendingOrder">
                                                        <td colspan="2"
                                                            style="line-height: 49px;font-size: 13px;color: #000000;padding-left: 20px;text-align:left;border-right: unset;">
                                                            SubTotal:</td>
                                                        <td colspan="3" class="price"
                                                            style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                            <b>₹{{PendingOrder.subTotal |
                                                                number:'1.2-2'}}</b>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="PendingOrder">
                                                        <td colspan="2"
                                                            style="line-height: 49px;font-size: 13px;color: #000000;padding-left: 20px;text-align:left;border-right: unset;">
                                                            SubTotal:</td>
                                                        <td colspan="3" class="price"
                                                            style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                            <b>₹{{PendingOrder.txa |
                                                                number:'1.2-2'}}</b>
                                                        </td>
                                                    </tr>

                                                    <tr *ngIf="PendingOrder">
                                                        <td colspan="2"
                                                            style="line-height: 49px;font-size: 13px;color: #000000;padding-left: 20px;text-align:left;border-right: unset;">
                                                            SubTotal:</td>
                                                        <td colspan="3" class="price"
                                                            style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                            <b>₹{{PendingOrder.ta |
                                                                number:'1.2-2'}}</b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table cellpadding="0" cellspacing="0" border="0" align="left"
                                                style="width: 100%;margin-top: 30px;    margin-bottom: 30px;">
                                                <tbody>
                                                    <tr *ngIf="PendingOrder">
                                                        <td>
                                                            <h5
                                                                style="font-size: 16px; font-weight: 500;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                DILIVERY ADDRESS</h5>
                                                            <p
                                                                style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                {{PendingOrder.ca.Address}}</p>
                                                        </td>
                                                        <td width="57" height="25" class="user-info"><img
                                                                src="../assets/images/Delivery-det/space.jpg" alt=" "
                                                                height="25" width="57"></td>
                                                        <td>
                                                            <h5
                                                                style="font-size: 16px;font-weight: 500;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                SHIPPING ADDRESS</h5>
                                                            <p
                                                                style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                268 Cambridge Lane New Albany, IN 47150268
                                                                Cambridge
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-style: none;"></td>
                                                        <td style="border-style: none;"></td>
                                                        <td style="border-style: none;float: inline-end;">
                                                            <button type="submit" class="btn-solid btn btn-sm"
                                                                (click)="back()">
                                                                Back
                                                            </button>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>


                                        </td>
                                    </tr>


                                </tbody>



                            </div>
                        </div> -->


                    </div>
                    <div class="col-lg-8 col-sm-12 col-xs-12 mobile-cart-content1">

                        <div class="checkout-details " *ngIf="mainhide == false && hide == false"
                            style="padding: 12px;border: 0;">
                            <div class="order-box">

                                <div class="checkout-title">
                                    <div class="row">
                                        <div class="col-8">
                                            <h4>Orders</h4>
                                        </div>
                                        <div class="col-4" style="padding: 0,10">
                                            <div>
                                                <select [(ngModel)]="Ofiltid" (change)="sorting($event)"
                                                    style="height: 25px; font-size: 10px; text-align: left; padding: 0 5px;">
                                                    <option value="0" [selected]="0">Current Month</option>
                                                    <option value="1" [selected]="1">Current Year</option>
                                                    <option value="2" [selected]="2">All Orders</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <table class="table cart-table table-responsive-xs">
                                    <thead>

                                        <!-- <tr><th>DeliveryDate&Time</th>
                                            <th>Invoice-Id</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                            <th>Details</th>
                                        </tr> -->
                                    </thead>

                                    <tbody>
                                        <!-- <tr *ngFor="let ord of Order">
                                           
                                            <td style="width: 20%;">
                                                <span>{{ord.didt | date: "d MMM Y | hh:mm: a" }}</span>

                                                <div class="mobile-cart-content row">
                                                    <div class="col-12">

                                                        <strong *ngIf="ord.osi == 1">
                                                            <p>Your Order is Preparing</p>
                                                        </strong>
                                                        <strong *ngIf="ord.osi > 1">
                                                            <p style="color: green;">Your Order is Completed</p>
                                                        </strong>

                                                    </div><br>
                                                    <div class="col-12">

                                                        <span>#Order-ID:</span> <strong
                                                            style="padding-left: 10px;"><span
                                                                style="color: #ff4c3b;margin-left: 5px;">#{{ord.ino}}{{ord.Id}}</span></strong>

                                                    </div>

                                                    <div style="margin-top: 15px;">
                                                        <a href="javascript:void(0)"
                                                            (click)="getDetails(ord.Id,ord.osi)"
                                                            style="color: #4b91f6;">View
                                                            Order<span
                                                                style="color: #4b91f6;margin-left: 5px;font-size: 16px;margin-left: 10px;">

                                                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>

                                            <td style="width:30%;"> <span
                                                    style="color: #ff4c3b;margin-left: 5px;">#{{PendingOrder.ino}}{{PendingOrder.Id}}</span>
                                            </td>

                                            <td style="width: 20%;"> &#8377;{{ord.ta | number:'1.2-2'}}</td>

                                            <td style="width: 20%;">
                                                <strong *ngIf="ord.osi == 1">Pending</strong>
                                                <strong *ngIf="ord.osi > 1">Completed</strong>

                                            </td>

                                            <td style="width: 10%;">
                                                <a (click)="getDetails(ord.Id,ord.osi)">
                                                    <strong><i class="fa fa-info-circle trackicon"
                                                            aria-hidden="true"></i></strong>

                                                </a>
                                            </td>

                                        </tr> -->

                                        <tr *ngFor="let ord of Order" style="font-size:11px;">
                                            <td>Order ID - <span style="color: red;"
                                                    *ngIf="ord.oi > 0">{{ord.oi}}</span> <span>_{{ord.id}}</span><br>
                                                <div class="row" style="margin-top: 5px;">

                                                    <div class="col-4">{{ord.didt | date: "d MMM Y"}}<br>{{ord.didt |
                                                        date:"hh:mm: a" }}</div>
                                                    <div class="col-4">({{ord.j.length}} Items)</div>
                                                    <div class="col-4"> ₹ {{ord.ta | number:'1.2-2'}}</div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-8">
                                                        <p *ngIf="ord.osi >= 1 &&  ord.osi != 5"
                                                            style="font-size: 12px;">Your Order is
                                                            Preparing..</p>
                                                        <p *ngIf="ord.osi == 5" style="font-size: 12px;">Order
                                                            Delivered!</p>

                                                        <p *ngIf="ord.osi == -1" style="font-size: 12px;">Order
                                                            Cancelled!</p>
                                                        <p *ngIf="ord.osi == 0" style="font-size: 12px;">Order
                                                            Pending!</p>
                                                        <p *ngIf="ord.osi == -5" style="font-size: 12px;">Cancel Request
                                                            Pending!</p>
                                                    </div>


                                                    <div class="col-4" style="margin-top: 5px;">
                                                        <a (click)="getDetails(ord.id,ord.osi)">
                                                            <strong><i class="fa fa-chevron-right trackicon"
                                                                    aria-hidden="true"></i></strong>

                                                        </a>
                                                    </div>

                                                </div>
                                            </td>


                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>




                        <div class="order-box container" *ngIf="hide == false && mainhide == true">
                            <div class="row ">
                                <div class="col-9">
                                    <h2 style="font-size: larger;
                                        text-transform: capitalize;">Order Details</h2>
                                </div>


                                <div class="col-3">
                                    <button type="submit" class="btn-solid btn btn-sm float-end"
                                        style="font-size: smaller; padding: 5px;" (click)="back()">
                                        < Back </button>
                                </div>
                            </div>


                            <button type="button" class="btn" (click)="drowopen()">
                            </button>

                            <div class="order-details" style="padding: 15px; font-family: Arial, sans-serif;    border: groove;
                            border-width: thin;
                        ">
                                <div class="header"
                                    style="display: flex; justify-content: space-between; align-items: center;">
                                    <h4 style="margin: 0;">Hi {{PendingOrder.ca.Name}},</h4>
                                    <a href="javascript:void(0)" (click)="Trackshow()"
                                        style="color: red; font-size: 14px;">Track Order</a>
                                </div>

                                <div style="margin: 10px 0; font-size: 14px;">
                                    <span style="color: #ff4c3b"><strong style="color: black">Order ID:</strong>
                                        {{PendingOrder.ino}}|{{PendingOrder.Id}}</span>
                                    <span style="margin-left: 15px; cursor: pointer;" (click)="generatePDF('download')">
                                        <i class="fa fa-download" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div>
                                    <a style="float: inline-end;color: #ff4c3b;"
                                        *ngIf="hidecancelbtn == true && PendingOrder.osi != -5"
                                        href="javascript:void(0)" (click)="cancelOrder()"><i class="fa fa-times-circle"
                                            aria-hidden="true"></i><span style="margin-left: 5px;">Cancel
                                            Order</span> </a>

                                    <a style="float: inline-end;color: orange;"
                                        *ngIf="hidecancelbtn == true && PendingOrder.osi == -5"
                                        href="javascript:void(0)" (click)="cancelOrder()"><i class="fa fa-times-circle"
                                            aria-hidden="true"></i><span style="margin-left: 5px;">Cancel
                                            Pending</span> </a>
                                </div>


                                <div style="margin: 10px 0;">
                                    <p *ngIf="PendingOrder.osi === 5" style="font-size: 14px; color: green;">Your Order
                                        is Successfully Delivered.</p>
                                    <p *ngIf="PendingOrder.osi === -5" style="font-size: 14px; color: orange;">Your
                                        Cancel Request is Pending.</p>
                                    <p *ngIf="PendingOrder.osi !== 5 && PendingOrder.osi !== -5 &&  PendingOrder.osi !== -1 && PendingOrder.osi !== 0"
                                        style="font-size: 14px; color: gray;">Order is Processed and On the Way.</p>

                                    <p *ngIf="PendingOrder.osi == -1" style="font-size: 14px; color: red;">Your order
                                        has been canceled.</p>

                                    <p *ngIf="PendingOrder.osi == 0" style="font-size: 14px; color: orange;">Your order
                                        is Pending!.</p>


                                </div>





                                <div style="font-size: 12px;">
                                    <strong>Deliver To:</strong> {{PendingOrder.ca.Name.toUpperCase()}}<br>
                                    {{PendingOrder.ca.Address.toUpperCase()}}<br>
                                    <strong>Phone:</strong> {{PendingOrder.ca.PhoneNo}}
                                </div>

                                <div class="product-details"
                                    style="margin: 15px 0; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                                    <div style="display: flex; padding: 10px;">
                                        <img src="{{PendingOrder.j[0]?.product.img}}" alt="Product Image"
                                            style="width: 80px; height: 80px; border-radius: 5px;">
                                        <div style="margin-left: 10px; flex-grow: 1;">
                                            <h5 style="margin: 0; font-size: 14px;">
                                                {{PendingOrder.j[0]?.product.name.toUpperCase()}} -
                                                {{PendingOrder.j[0]?.product.wg_qty}} KG</h5>
                                            <p style="margin: 5px 0; font-size: 12px; color: #555;">
                                                {{PendingOrder.j[0]?.product.message}}</p>
                                            <div
                                                style="display: flex; justify-content: space-between; font-size: 12px;">
                                                <span><strong>Qty:</strong>
                                                    {{PendingOrder.j[0]?.product.quantity}}</span>
                                                <span><strong>Price:</strong>
                                                    ₹{{PendingOrder.j[0]?.product.prodtotal}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="summary"
                                    style="margin: 15px 0; padding: 10px; background-color: beige; border-radius: 5px; font-size: 14px;">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span>Subtotal:</span>
                                        <span>₹{{PendingOrder.subTotal | number:'1.2-2'}}</span>
                                    </div>
                                    <div style="display: flex; justify-content: space-between;">
                                        <span>Tax (18%):</span>
                                        <span>₹{{PendingOrder.txa | number:'1.2-2'}}</span>
                                    </div>
                                    <div style="display: flex; justify-content: space-between; font-weight: bold;">
                                        <span>Total:</span>
                                        <span>₹{{PendingOrder.ta | number:'1.2-2'}}</span>
                                    </div>

                                    <div class="row"
                                        *ngIf="PendingOrder.pti == 1 && PendingOrder.osi !=5 && PendingOrder.osi !=-5 && PendingOrder.ts != 1">
                                        <a href="javascript:void(0)" style=" margin-top: 10px;"
                                            (click)="proceedToPayment()"><i class="fa fa-credit-card"
                                                aria-hidden="true"></i>
                                            Proceed to Payment
                                        </a>
                                    </div>
                                </div>

                                <div style="text-align: center; font-size: 12px; color: gray;">
                                    Payment Mode: <span *ngIf="PendingOrder.pti === 2">Cash Pay</span>
                                    <span *ngIf="PendingOrder.pti === 1">Online Pay</span> <br>


                                    <span *ngIf="PendingOrder.ts == 1" style="color: green;">Payment
                                        Success</span>
                                    <span *ngIf="PendingOrder.ts == -1" style="color: red;">Payment
                                        Failed</span>
                                    <span *ngIf="PendingOrder.ts == 0" style="color:orange;">Payment
                                        Pending</span>


                                </div>
                            </div>


                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</section>


<div style="display: none;" id="preloaderom">
    <!-- <img  alt=""> -->
    <div id="loaderom">
        <div class="loaderzig">
            <div class="loader__part loader__part--1"></div>
            <div class="loader__part loader__part--2"></div>
            <div class="loader__part loader__part--3"></div>
        </div>
    </div>
</div>

<div [@slideInOut]="menuState" style="position: fixed; background-color:#ffffff;
left: auto; top: 0;
right: 0;
bottom: 0;
width: 20%; padding-left: 10px; padding-top: 100px;
min-width: 250px;
z-index: 9999;">



    <div class="checkout-details" style="margin-bottom: 20px;border: 0;" *ngIf="trackordhide == true" id="pendingorder">

        <div class="checkout-title" *ngIf="PendingOrder">

            <p style="margin: 0;">
                <strong style="font-size: 12px;">OrderId:</strong><span
                    style="color: #ff4c3b;margin-left: 5px; font-size: 12px;">#{{PendingOrder.ino}}{{PendingOrder.Id}}</span>
            </p>
            <!-- <p><strong>Estimated Delivery:</strong> {{PendingOrder.didt | date:
               "d MMM Y" }} </p> -->

        </div>
        <br>
        <div class="stepper-vertical" id="stepper2" *ngIf="PendingOrder.osi > -1" id="orderstatus">
            <div class="step editing">
                <div class="step-container col-12">
                    <div class="step-title col-1"></div>
                    <div class="step-circle col-2"><span style="font-size: 13px;">1</span></div>
                    <div class="step-title col-9" style="font-size: 10px; margin-top: 10px;">Order Pending</div>
                </div>
                <div class="step-container col-12">
                    <div class="col-1"></div>
                    <div class="step-bar col-2"></div>
                    <div class="col-9"></div>
                </div>
            </div>
            <div class="step">
                <div class="step-container col-12">
                    <div class="step-title col-1"></div>
                    <div class="step-circle col-2"><span style="font-size: 13px;">2</span></div>
                    <div class="step-title col-9" style="font-size: 10px; margin-top: 10px;">Order Received</div>
                </div>
                <div class="step-container col-12">
                    <div class="col-1"></div>
                    <div class="step-bar col-2"></div>
                    <div class="col-9"></div>
                </div>
            </div>
            <div class="step">
                <div class="step-container col-12">
                    <div class="step-title col-1"></div>
                    <div class="step-circle col-2"><span style="font-size: 13px;">3</span></div>
                    <div class="step-title col-9" style="font-size: 10px; margin-top: 10px;">Order Processing</div>
                </div>
                <div class="step-container col-12">
                    <div class="col-1"></div>
                    <div class="step-bar col-2"></div>
                    <div class="col-9"></div>
                </div>
            </div>
            <div class="step">
                <div class="step-container col-12">
                    <div class="step-title col-1"></div>
                    <div class="step-circle col-2"><span style="font-size: 13px;">4</span></div>
                    <div class="step-title col-9" style="font-size: 10px; margin-top: 10px;">Out Of Delivery</div>
                </div>
                <div class="step-container col-12">
                    <div class="col-1"></div>
                    <div class="step-bar col-2"></div>
                    <div class="col-9"></div>
                </div>
            </div>
            <div class="step">
                <div class="step-container  col-12">
                    <div class="step-title col-1"></div>
                    <div class="step-circle  col-2"><span style="font-size: 13px;">5</span></div>
                    <div class="step-title  col-9" style="font-size: 10px; margin-top: 10px;">
                        <span *ngIf="OrdStatusID!=5">Order will Arrive on</span>
                        <span *ngIf="OrdStatusID==5">Order Delivered</span>

                        <br>
                        <p *ngIf="PendingOrder" style="font-size: 10px;">{{PendingOrder.didt
                            | date: "d MMM Y | hh:mm: a" }}</p>
                    </div>
                </div>
            </div>
        </div>

        <span *ngIf="PendingOrder.osi == -1" style="color: red;font-size: 18px;">Order
            Cancelled</span>

        <span *ngIf="PendingOrder.osi == -5" style="color: rgb(238, 157, 36);">Your
            Cancel Request is Pending <i class="fa fa-clock-o" aria-hidden="true"></i></span>


        <div style="margin-top: 20px;">
            <a (click)="drowopen()">
                <strong><i class="fa fa-chevron-right trackicon" aria-hidden="true"></i> </strong>

            </a>
        </div>
    </div>

</div>


<ng-template #Reviewmodel let-modal>
    <div class="modal-body" id="reviewmodel">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body" *ngIf="revieworddata">

                    <div class="col-lg-12 row">
                        <!-- <div class="col-lg-2">

                        </div> -->
                        <div class="col-4">
                            <div>
                                <img src="{{revieworddata.img}}" alt="" style="width: 115Px;
                                height: 115px;
                                object-fit: cover;">
                            </div>
                        </div>
                        <div class="col-8">
                            <h4 style="    margin-top: 30px;font-size: 20px;">{{revieworddata.name}} </h4>
                            <span> {{revieworddata.wg_qtytxt}}</span>
                        </div>
                        <!-- <div class="col-2">

                        </div> -->

                    </div><br>
                    <div class="col-12">
                        <textarea name="" id=""
                            style="width: inherit;    height: 100px;    padding: 10px;    border-color: #ff4c3b;"
                            placeholder="Write Your Honest Review" maxlength="500" [(ngModel)]="textarea"></textarea>
                    </div>


                    <!-- <div class="media-body ms-3" style="text-align: center;margin-left: 0;    margin-top: 10px;" [ngModel]="rating">
                            <label style="text-align: center;    font-size: large;">Rating</label>
                            <div class="rating three-star" style="font-size: 30px;">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </div>
                        </div> -->


                    <div class="media-body ms-3" style="text-align: center; margin-left: 0; margin-top: 10px;">
                        <label style="text-align: center; font-size: large;">Rating</label>
                        <div class="rating" style="font-size: 30px;">
                            <i class="fa fa-star" *ngFor="let star of stars; let i = index" [class.filled]="i < rating"
                                (click)="giveratings(i + 1)">
                            </i>
                        </div>
                    </div> <br>
                    <div style="text-align: center;">
                        <p *ngIf="rating == 1" style="    color: rgb(162 205 171);font-style: italic;"> Thanks! You
                            rated
                            this {{rating}} stars.
                            <span> <svg style="height: 30px;width: 30px;object-fit: cover;"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <circle cx="256" cy="256" r="256" fill="#ffd93b" />
                                    <path
                                        d="M512 256A256 256 0 0 1 56.7 416.7a256 256 0 0 0 360-360c58.1 47 95.3 118.8 95.3 199.3z"
                                        fill="#f4c534" />
                                    <path
                                        d="M328.4 428a92.8 92.8 0 0 0-145-.1 6.8 6.8 0 0 1-12-5.8 86.6 86.6 0 0 1 84.5-69 86.6 86.6 0 0 1 84.7 69.8c1.3 6.9-7.7 10.6-12.2 5.1z"
                                        fill="#3e4347" />
                                    <path
                                        d="M269.2 222.3c5.3 62.8 52 113.9 104.8 113.9 52.3 0 90.8-51.1 85.6-113.9-2-25-10.8-47.9-23.7-66.7-4.1-6.1-12.2-8-18.5-4.2a111.8 111.8 0 0 1-60.1 16.2c-22.8 0-42.1-5.6-57.8-14.8-6.8-4-15.4-1.5-18.9 5.4-9 18.2-13.2 40.3-11.4 64.1z"
                                        fill="#f4c534" />
                                    <path
                                        d="M357 189.5c25.8 0 47-7.1 63.7-18.7 10 14.6 17 32.1 18.7 51.6 4 49.6-26.1 89.7-67.5 89.7-41.6 0-78.4-40.1-82.5-89.7A95 95 0 0 1 298 174c16 9.7 35.6 15.5 59 15.5z"
                                        fill="#fff" />
                                    <path
                                        d="M396.2 246.1a38.5 38.5 0 0 1-38.7 38.6 38.5 38.5 0 0 1-38.6-38.6 38.6 38.6 0 1 1 77.3 0z"
                                        fill="#3e4347" />
                                    <path
                                        d="M380.4 241.1c-3.2 3.2-9.9 1.7-14.9-3.2-4.8-4.8-6.2-11.5-3-14.7 3.3-3.4 10-2 14.9 2.9 4.9 5 6.4 11.7 3 15z"
                                        fill="#fff" />
                                    <path
                                        d="M242.8 222.3c-5.3 62.8-52 113.9-104.8 113.9-52.3 0-90.8-51.1-85.6-113.9 2-25 10.8-47.9 23.7-66.7 4.1-6.1 12.2-8 18.5-4.2 16.2 10.1 36.2 16.2 60.1 16.2 22.8 0 42.1-5.6 57.8-14.8 6.8-4 15.4-1.5 18.9 5.4 9 18.2 13.2 40.3 11.4 64.1z"
                                        fill="#f4c534" />
                                    <path
                                        d="M155 189.5c-25.8 0-47-7.1-63.7-18.7-10 14.6-17 32.1-18.7 51.6-4 49.6 26.1 89.7 67.5 89.7 41.6 0 78.4-40.1 82.5-89.7A95 95 0 0 0 214 174c-16 9.7-35.6 15.5-59 15.5z"
                                        fill="#fff" />
                                    <path
                                        d="M115.8 246.1a38.5 38.5 0 0 0 38.7 38.6 38.5 38.5 0 0 0 38.6-38.6 38.6 38.6 0 1 0-77.3 0z"
                                        fill="#3e4347" />
                                    <path
                                        d="M131.6 241.1c3.2 3.2 9.9 1.7 14.9-3.2 4.8-4.8 6.2-11.5 3-14.7-3.3-3.4-10-2-14.9 2.9-4.9 5-6.4 11.7-3 15z"
                                        fill="#fff" />
                                </svg></span>
                        </p>

                        <p *ngIf="rating == 2" style="    color: rgb(162 205 171);font-style: italic;"> Thanks! You
                            rated
                            this {{rating}} stars.
                            <span> <svg style="height: 30px;width: 30px;object-fit: cover;"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <circle cx="256" cy="256" r="256" fill="#ffd93b" />
                                    <path
                                        d="M512 256A256 256 0 0 1 56.7 416.7a256 256 0 0 0 360-360c58.1 47 95.3 118.8 95.3 199.3z"
                                        fill="#f4c534" />
                                    <path
                                        d="M336.6 403.2c-6.5 8-16 10-25.5 5.2a117.6 117.6 0 0 0-110.2 0c-9.4 4.9-19 3.3-25.6-4.6-6.5-7.7-4.7-21.1 8.4-28 45.1-24 99.5-24 144.6 0 13 7 14.8 19.7 8.3 27.4z"
                                        fill="#3e4347" />
                                    <path d="M276.6 244.3a79.3 79.3 0 1 1 158.8 0 79.5 79.5 0 1 1-158.8 0z"
                                        fill="#fff" />
                                    <circle cx="340" cy="260.4" r="36.2" fill="#3e4347" />
                                    <g fill="#fff">
                                        <ellipse transform="rotate(-135 326.4 246.6)" cx="326.4" cy="246.6" rx="6.5"
                                            ry="10" />
                                        <path d="M231.9 244.3a79.3 79.3 0 1 0-158.8 0 79.5 79.5 0 1 0 158.8 0z" />
                                    </g>
                                    <circle cx="168.5" cy="260.4" r="36.2" fill="#3e4347" />
                                    <ellipse transform="rotate(-135 182.1 246.7)" cx="182.1" cy="246.7" rx="10" ry="6.5"
                                        fill="#fff" />
                                </svg></span>
                        </p>
                        <p *ngIf="rating == 3" style="    color: rgb(162 205 171);font-style: italic;"> Thanks! You
                            rated
                            this {{rating}} stars.
                            <span> <svg style="height: 30px;width: 30px;object-fit: cover;"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <circle cx="256" cy="256" r="256" fill="#ffd93b" />
                                    <path
                                        d="M407.7 352.8a163.9 163.9 0 0 1-303.5 0c-2.3-5.5 1.5-12 7.5-13.2a780.8 780.8 0 0 1 288.4 0c6 1.2 9.9 7.7 7.6 13.2z"
                                        fill="#3e4347" />
                                    <path
                                        d="M512 256A256 256 0 0 1 56.7 416.7a256 256 0 0 0 360-360c58.1 47 95.3 118.8 95.3 199.3z"
                                        fill="#f4c534" />
                                    <g fill="#fff">
                                        <path
                                            d="M115.3 339c18.2 29.6 75.1 32.8 143.1 32.8 67.1 0 124.2-3.2 143.2-31.6l-1.5-.6a780.6 780.6 0 0 0-284.8-.6z" />
                                        <ellipse cx="356.4" cy="205.3" rx="81.1" ry="81" />
                                    </g>
                                    <ellipse cx="356.4" cy="205.3" rx="44.2" ry="44.2" fill="#3e4347" />
                                    <g fill="#fff">
                                        <ellipse transform="scale(-1) rotate(45 454 -906)" cx="375.3" cy="188.1" rx="12"
                                            ry="8.1" />
                                        <ellipse cx="155.6" cy="205.3" rx="81.1" ry="81" />
                                    </g>
                                    <ellipse cx="155.6" cy="205.3" rx="44.2" ry="44.2" fill="#3e4347" />
                                    <ellipse transform="scale(-1) rotate(45 454 -421.3)" cx="174.5" cy="188" rx="12"
                                        ry="8.1" fill="#fff" />
                                </svg></span>
                        </p>
                        <p *ngIf="rating == 4" style="    color: rgb(162 205 171);font-style: italic;"> Thanks! You
                            rated
                            this {{rating}} stars.
                            <span> <svg style="height: 30px;width: 30px;object-fit: cover;"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <circle cx="256" cy="256" r="256" fill="#ffd93b" />
                                    <path
                                        d="M512 256A256 256 0 0 1 56.7 416.7a256 256 0 0 0 360-360c58.1 47 95.3 118.8 95.3 199.3z"
                                        fill="#f4c534" />
                                    <path
                                        d="M232.3 201.3c0 49.2-74.3 94.2-74.3 94.2s-74.4-45-74.4-94.2a38 38 0 0 1 74.4-11.1 38 38 0 0 1 74.3 11.1z"
                                        fill="#e24b4b" />
                                    <path
                                        d="M96.1 173.3a37.7 37.7 0 0 0-12.4 28c0 49.2 74.3 94.2 74.3 94.2C80.2 229.8 95.6 175.2 96 173.3z"
                                        fill="#d03f3f" />
                                    <path
                                        d="M215.2 200c-3.6 3-9.8 1-13.8-4.1-4.2-5.2-4.6-11.5-1.2-14.1 3.6-2.8 9.7-.7 13.9 4.4 4 5.2 4.6 11.4 1.1 13.8z"
                                        fill="#fff" />
                                    <path
                                        d="M428.4 201.3c0 49.2-74.4 94.2-74.4 94.2s-74.3-45-74.3-94.2a38 38 0 0 1 74.4-11.1 38 38 0 0 1 74.3 11.1z"
                                        fill="#e24b4b" />
                                    <path
                                        d="M292.2 173.3a37.7 37.7 0 0 0-12.4 28c0 49.2 74.3 94.2 74.3 94.2-77.8-65.7-62.4-120.3-61.9-122.2z"
                                        fill="#d03f3f" />
                                    <path
                                        d="M411.3 200c-3.6 3-9.8 1-13.8-4.1-4.2-5.2-4.6-11.5-1.2-14.1 3.6-2.8 9.7-.7 13.9 4.4 4 5.2 4.6 11.4 1.1 13.8z"
                                        fill="#fff" />
                                    <path
                                        d="M381.7 374.1c-30.2 35.9-75.3 64.4-125.7 64.4s-95.4-28.5-125.8-64.2a17.6 17.6 0 0 1 16.5-28.7 627.7 627.7 0 0 0 218.7-.1c16.2-2.7 27 16.1 16.3 28.6z"
                                        fill="#3e4347" />
                                    <path
                                        d="M256 438.5c25.7 0 50-7.5 71.7-19.5-9-33.7-40.7-43.3-62.6-31.7-29.7 15.8-62.8-4.7-75.6 34.3 20.3 10.4 42.8 17 66.5 17z"
                                        fill="#e24b4b" />
                                </svg></span>
                        </p>
                        <p *ngIf="rating == 5" style="    color: rgb(162 205 171);font-style: italic;"> Thanks! You
                            rated
                            this {{rating}} stars.
                            <span> <svg style="height: 30px;width: 30px;object-fit: cover;"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <g fill="#ffd93b">
                                        <circle cx="256" cy="256" r="256" />
                                        <path
                                            d="M512 256A256 256 0 0 1 56.8 416.7a256 256 0 0 0 360-360c58 47 95.2 118.8 95.2 199.3z" />
                                    </g>
                                    <path
                                        d="M512 99.4v165.1c0 11-8.9 19.9-19.7 19.9h-187c-13 0-23.5-10.5-23.5-23.5v-21.3c0-12.9-8.9-24.8-21.6-26.7-16.2-2.5-30 10-30 25.5V261c0 13-10.5 23.5-23.5 23.5h-187A19.7 19.7 0 0 1 0 264.7V99.4c0-10.9 8.8-19.7 19.7-19.7h472.6c10.8 0 19.7 8.7 19.7 19.7z"
                                        fill="#e9eff4" />
                                    <path
                                        d="M204.6 138v88.2a23 23 0 0 1-23 23H58.2a23 23 0 0 1-23-23v-88.3a23 23 0 0 1 23-23h123.4a23 23 0 0 1 23 23z"
                                        fill="#45cbea" />
                                    <path
                                        d="M476.9 138v88.2a23 23 0 0 1-23 23H330.3a23 23 0 0 1-23-23v-88.3a23 23 0 0 1 23-23h123.4a23 23 0 0 1 23 23z"
                                        fill="#e84d88" />
                                    <g fill="#38c0dc">
                                        <path
                                            d="M95.2 114.9l-60 60v15.2l75.2-75.2zM123.3 114.9L35.1 203v23.2c0 1.8.3 3.7.7 5.4l116.8-116.7h-29.3z" />
                                    </g>
                                    <g fill="#d23f77">
                                        <path
                                            d="M373.3 114.9l-66 66V196l81.3-81.2zM401.5 114.9l-94.1 94v17.3c0 3.5.8 6.8 2.2 9.8l121.1-121.1h-29.2z" />
                                    </g>
                                    <path
                                        d="M329.5 395.2c0 44.7-33 81-73.4 81-40.7 0-73.5-36.3-73.5-81s32.8-81 73.5-81c40.5 0 73.4 36.3 73.4 81z"
                                        fill="#3e4347" />
                                    <path
                                        d="M256 476.2a70 70 0 0 0 53.3-25.5 34.6 34.6 0 0 0-58-25 34.4 34.4 0 0 0-47.8 26 69.9 69.9 0 0 0 52.6 24.5z"
                                        fill="#e24b4b" />
                                    <path
                                        d="M290.3 434.8c-1 3.4-5.8 5.2-11 3.9s-8.4-5.1-7.4-8.7c.8-3.3 5.7-5 10.7-3.8 5.1 1.4 8.5 5.3 7.7 8.6z"
                                        fill="#fff" opacity=".2" />
                                </svg></span>
                        </p>




                    </div>


                    <div>
                        <h5 style="font-weight: 700;font-size: 20px;">Upload Image</h5>

                        <p style="    margin-bottom: 5px;">*Allowed only files with extension (jpg, png)</p>
                        <p>*Maximum number of allowed files 2 with max size 10 MB for each</p>
                    </div>


                    <!-- <h3>Repeatable with Ajax</h3> -->

                    <!-- <div class="col-12" style="margin-top: 25px;">
                        <div class="row">
                            <div class="col-3">
                                <label class="image-input withAjax">
                                    <input type="file" accept="image/png,image/jpeg" max-size="10000000" name="file"
                                        (change)="selectFile($event)">
                                    <input type="hidden" name="">
                                    <img src="" alt="">
                                </label>
                            </div>



                            <div class="col-3" *ngFor="let data of imgreview.imgs">
                                <label class="image-input withAjax">
                                    <input type="file" accept="image/png,image/jpeg" max-size="10000000" name="file"
                                        (change)="selectFile($event)">
                                    <input type="hidden" name="">
                                    <img src="{{data}}" alt="">
                                </label>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-12" style="margin-top: 25px;">
                        <div class="row">
                            <div class="col-3" *ngIf="imgreview.length < 2">
                                <label class="image-input withAjax">
                                    <!-- <input type="file" accept="image/png,image/jpeg" (change)="selectFile($event)"> -->
                                    <input type="file" accept="image/png,image/jpeg"
                                        (change)="upload($event.target.files)">
                                    <input type="hidden" name="">
                                    <img [src]="preview" *ngIf="preview" alt="">
                                </label>
                            </div>

                            <div class="col-3" *ngFor="let data of imgreview; let i = index">
                                <div class="image-input withAjax">
                                    <button type="button" class="remove-btn" (click)="removeImage(i)">
                                        <i style="font-size: 18px;" class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                    <img [src]="data.testurl" alt="">
                                </div>
                                <!-- <button type="button" class="remove-btn" (click)="removeImage(i)">
                                    <i class="fa fa-trash"></i>
                                </button> -->
                            </div>
                        </div>
                    </div>



                </div>
                <div class="modal-footer">
                    <!-- <span *ngIf="rating == 0" style="color: red;padding-right: 100px;    padding-right: 150px;    font-style: italic;">Please Select Star Rating!</span> -->


                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal"
                        (click)="close()">Cancel</button>
                    <button type="button" class="btn btn-solid btn-sm" style="padding: 4px 16px;" (click)="post()"
                        [disabled]="rating == 0">Post</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>







<!-- Cancel--order -->

<ng-template #Cancelord let-modal>
    <div class="modal-body" id="cancelord">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">


                    <div style="border-bottom-width: thin;border-bottom-style: outset;">
                        <h3 style="    color:black;">Cancel Order</h3>
                    </div>
                    <div style="margin-top: 20px;" *ngIf="PendingOrder.osi < 3 && timeExpire == false">
                        <h4 style="font-size: 16px;    color: #777777;">Do you want to send the order cancellation
                            request?</h4>
                    </div>

                    <div style="margin-top: 20px;" *ngIf="PendingOrder.osi > 2 || timeExpire == true">
                        <h4 style="font-size: 16px;    color: #777777;">Your Order was Processed. Cannot cancel your
                            Order</h4> <br>

                        <h6 style="font-size: 15px;color: red;"> Contact FBcakes Support : 90034 32888</h6>
                    </div>

                    <div style="margin-top: 20px;"
                        *ngIf="PendingOrder.osi < 3 && PendingOrder.osi != -5 && timeExpire == false">

                        <textarea name="" id=""
                            style="width: -webkit-fill-available;height: 100px;    padding: 10px;    border-color: #ff4c3b;"
                            placeholder="Reason for cancellation" maxlength="250" [(ngModel)]="cancelreason"></textarea>

                        <span *ngIf="submit == true && this.cancelreason.length < 40"
                            style="color: red;font-style: italic;">Reason above 40 char</span>



                    </div>

                    <div style="margin-top: 20px;"
                        *ngIf="PendingOrder.osi < 3 && PendingOrder.osi != -5 && timeExpire == true">

                        <div class="row">
                            <div class="col-lg-6">
                                <h5 class="text-center">Store Name:</h5>
                            </div>
                            <div class="col-lg-6">
                                {{posOrder[0].name}}
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <h5 class="text-center">Contact No:</h5>
                            </div>
                            <div class="col-lg-6">
                                {{posOrder[0].contactNo}}
                            </div>

                        </div>


                    </div>

                    <div *ngIf="PendingOrder.osi == -5">
                        <p style="margin-top: 20px;"> <span>Reason:</span> <span
                                style="font-size: 18px;color: #0a0a0a;">{{cancelreason}}</span></p>
                    </div>


                </div>
                <div class="modal-footer">
                    <button *ngIf="PendingOrder.osi > 2 || PendingOrder.osi == -5" type="button"
                        class="btn btn-theme btn-sm" (click)="modal.dismiss('Cross click')">Close</button>

                    <button *ngIf="PendingOrder.osi == 0 || PendingOrder.osi == 1 || PendingOrder.osi == 2"
                        type="button" class="btn btn-theme btn-sm"
                        (click)="SubmitCancelorder(PendingOrder)">Submit</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>




<!-- <button class="btn-btn-solid" (click)="findMe()">findMe</button> -->






<ng-template #paymentModal let-modal>
    <div>

    </div>
    <div class="modal-body" id="paymentmodal">
        <!-- <div class="container-fluid p-0"> -->
        <!-- Modal Header -->
        <div class="text-center py-3">
            <i class="fa fa-credit-card-alt" aria-hidden="true"
                style="width: 40px; margin-bottom: 12px;font-size: 40px;color: orangered;"></i>
            <h4 style="font-size: 20px; font-weight: 600; color: #333;">Your order is almost done!</h4>
        </div>

        <!-- Modal Body -->
        <div class="text-center py-3">
            <p style="font-size: 16px; color: #666;">Complete your payment to finalize the order.</p>
        </div>

        <!-- Modal Footer -->
        <div class="d-flex flex-column align-items-center">
            <button type="button" class="btn btn-secondary btn-lg w-100 mb-3" (click)="continuePay()"
                style="font-size: 16px; font-weight: 500; background-color: orangered; color: #fff; border: 1px solid #ddd; border-radius: 8px;">
                Continue With Payment
            </button>
            <button type="button" class="btn btn-primary btn-lg w-100"
                style="font-size: 16px; font-weight: 500; background-color:#f8f9fa ; color: #333; border-radius: 8px;"
                (click)="modal.dismiss('Go back click')">
                Go back
            </button>
        </div>
        <!-- </div> -->
    </div>
</ng-template>


<div style="display: none;" id="orderload">
    <!-- <img  alt=""> -->
    <div id="loadercrt">
        <div class="loaderzig">
            <div class="loader__part loader__part--1"></div>
            <div class="loader__part loader__part--2"></div>
            <div class="loader__part loader__part--3"></div>
        </div>
    </div>
</div>